// File: DiscussionModal.tsx
import React, { useState } from 'react';
import { getUniqueTags } from './utils';
import { Dropdown, DropdownProps, Button, Form, Input, TextArea, List, Container, Radio,   ModalHeader,
    ModalDescription,
    ModalContent,
    ModalActions,
    Header,
    Image,
    Modal,} from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';

interface DiscussionModalProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
    title: string;
    setTitle: (value: string) => void;
    content: string;
    setContent: (value: string) => void;
    tagInput: string;
    setTagInput: (value: string) => void;
    tags: string[];
    setTags: (tags: string[]) => void;
    handleAddTag: () => void;
    handleRemoveTag: (index: number) => void;
    handleAnonymityChange: (e: React.FormEvent<HTMLInputElement>, data: any) => void;
    handleNotifyChange: (e: React.FormEvent<HTMLInputElement>, data: any) => void;
    type: 'note' | 'discussion';
    handleTypeChange: (event: any, data: any) => void;
    existingTags: string[];
}

const DiscussionModal: React.FC<DiscussionModalProps> = ({
                                                             open,
                                                             setOpen,
                                                             handleSubmit,
                                                             title,
                                                             setTitle,
                                                             content,
                                                             setContent,
                                                             tagInput,
                                                             setTagInput,
                                                             tags,
                                                             setTags,
                                                             handleAddTag,
                                                             handleRemoveTag,
                                                             handleAnonymityChange,
                                                             handleNotifyChange,
                                                             type,
                                                             handleTypeChange,
                                                             existingTags,
                                                         }) => {
    return (
        <Modal
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            open={open}
            size="small"
        >
            <Modal.Header>Ask A Question</Modal.Header>
            <Modal.Content>
        <Form onSubmit={handleSubmit}>
            <Form.Field>
                <label>Title</label>
                <Form.Input
                    placeholder="Enter title"
                    name="title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                />
            </Form.Field>

            <Form.Field>
                <label>Content</label>
                <TextArea
                    placeholder="Enter content"
                    name="content"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    required
                />
            </Form.Field>

            <Form.Field>
                <label>Type</label>
                <Dropdown
                    placeholder="Select type"
                    fluid
                    selection
                    options={['Discussion', 'Note'].map((type) => ({
                        key: type.toLowerCase(),
                        text: type,
                        value: type.toLowerCase(),
                    }))}
                    name="type"
                    defaultValue={'discussion'}
                    onChange={handleTypeChange}
                />
                {type === 'discussion' ? (
                    <p className="warning-message">
                        A Discussion post allows other users to reply to your post
                    </p>
                ) : (
                    <p className="warning-message">
                        A Note post is a one-way communication post that does not allow replies
                    </p>
                )}
            </Form.Field>

            <Form.Field>
                <label>Tags</label>
                <input
                    type="text"
                    id="tags"
                    value={tagInput}
                    onChange={(e) => setTagInput(e.target.value)}
                    list="existing-tags"
                    style={{ marginBottom: '10px' }}
                />
                <datalist id="existing-tags">
                    {existingTags.map((existingTag, index) => (
                        <option key={index} value={existingTag} />
                    ))}
                </datalist>
                <button type="button" className="tag-add-button" onClick={handleAddTag}>
                    Add Tag
                </button>
                <div className="tags-container">
                    {tags.map((tag, index) => (
                        <span key={index} className="tag">
              {tag}
                            <button
                                className="remove-tag-button"
                                onClick={() => handleRemoveTag(index)}
                            />
            </span>
                    ))}
                </div>
            </Form.Field>

            <Form.Field style={{ display: 'flex', alignItems: 'center' }}>
                <label style={{ marginRight: '10px' }}>I would like to be notified of replies</label>
                <Radio toggle defaultChecked={false} onChange={handleNotifyChange} />
            </Form.Field>

            <Form.Field style={{ display: 'flex', alignItems: 'center' }}>
                <label style={{ marginRight: '10px' }}> I want to keep my name and role private</label>
                <Radio toggle defaultChecked={false} onChange={handleAnonymityChange}  />
            </Form.Field>

            <Button type="submit" style={{ backgroundColor: '#059669', color: '#fff' }} primary fluid>
                Submit Post
            </Button>
        </Form>
            </Modal.Content>
        </Modal>
    );
};

export default DiscussionModal;
